import { render, staticRenderFns } from "./YaopinList.vue?vue&type=template&id=0c835f76&scoped=true&"
import script from "./YaopinList.vue?vue&type=script&lang=js&"
export * from "./YaopinList.vue?vue&type=script&lang=js&"
import style0 from "./YaopinList.vue?vue&type=style&index=0&id=0c835f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c835f76",
  null
  
)

export default component.exports